import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Package, Target, CheckCircle2 } from 'lucide-react';
export function Included() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-20 sm:py-32 bg-white" data-id="element-243">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-244">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-245">
          <div className="inline-flex items-center gap-2 bg-[#2F4538] text-[#F5F0E8] px-6 py-3 rounded-full mb-6" data-id="element-246">
            <Package className="w-5 h-5 text-[#D4AF37]" data-id="element-247" />
            <span className="font-bold tracking-wider uppercase text-sm" data-id="element-248">
              Lo que incluye el sistema
            </span>
          </div>
        </motion.div>

        {/* MÓDULO 1 */}
        <div data-id="element-249">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-[#F5F0E8] rounded-[2.5rem] p-8 sm:p-12 border border-[#D4AF37]/20 relative overflow-hidden" data-id="element-250">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#B4A7D6]/10 rounded-full blur-3xl -mr-32 -mt-32" data-id="element-251"></div>

            <div className="flex items-center gap-4 mb-8 relative z-10" data-id="element-252">
              <div className="w-14 h-14 bg-[#2F4538] rounded-2xl flex items-center justify-center shrink-0" data-id="element-253">
                <Target className="w-7 h-7 text-[#D4AF37]" data-id="element-254" />
              </div>
              <div data-id="element-255">
                <h3 className="text-sm font-bold text-[#B4A7D6] uppercase tracking-wider mb-1" data-id="element-256">
                  Núcleo del Sistema
                </h3>
                <h4 className="text-2xl sm:text-3xl font-bold text-[#2F4538] notranslate" translate="no" lang="es" data-id="element-257">
                  El Sistema E.R.A.
                </h4>
              </div>
            </div>

            <p className="text-xl font-medium text-[#1a1a1a]/80 mb-4 relative z-10" data-id="element-258">
              Más de 100 Rituales Organizados en el Método Exclusivo E.R.A.
            </p>
            <p className="text-[#1a1a1a]/70 mb-10 relative z-10" data-id="element-259">
              Este NO es un montón de recetas tiradas al azar. Es un sistema
              inteligente dividido en 3 pilares fundamentales:
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-12 relative z-10" data-id="element-260">
              {/* E */}
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-[#D4AF37]/10" data-id="element-261">
                <div className="text-4xl font-bold text-[#B4A7D6] mb-4 notranslate" translate="no" lang="es" data-id="element-262">
                  E
                </div>
                <h5 className="font-bold text-[#2F4538] text-lg mb-2" data-id="element-263">
                  EQUILIBRAR{' '}
                  <span className="text-sm font-normal text-[#1a1a1a]/50" data-id="element-264">
                    (25 rituales)
                  </span>
                </h5>
                <p className="text-sm text-[#1a1a1a]/70 mb-4" data-id="element-265">
                  Para cuando llegás del trabajo destruida y necesitás bajar
                  revoluciones YA.
                </p>
                <ul className="text-sm text-[#1a1a1a]/80 space-y-2 mb-4" data-id="element-266">
                  <li data-id="element-267">▸ Neutralizar el estrés</li>
                  <li data-id="element-268">▸ Bajar ansiedad en 10 min</li>
                  <li data-id="element-269">▸ Desconectar preocupaciones</li>
                </ul>
                <div className="bg-[#F5F0E8] p-3 rounded-xl text-xs font-medium text-[#2F4538]" data-id="element-270">
                  Ej: Ritual Express Anti-Estrés con Sal y Lavanda (5 min)
                </div>
              </div>

              {/* R */}
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-[#D4AF37]/10" data-id="element-271">
                <div className="text-4xl font-bold text-[#8B9D83] mb-4 notranslate" translate="no" lang="es" data-id="element-272">
                  R
                </div>
                <h5 className="font-bold text-[#2F4538] text-lg mb-2" data-id="element-273">
                  RENOVAR{' '}
                  <span className="text-sm font-normal text-[#1a1a1a]/50" data-id="element-274">
                    (40 rituales)
                  </span>
                </h5>
                <p className="text-sm text-[#1a1a1a]/70 mb-4" data-id="element-275">
                  Para cuando sentís que tu energía está pesada, bloqueada o
                  "rara".
                </p>
                <ul className="text-sm text-[#1a1a1a]/80 space-y-2 mb-4" data-id="element-276">
                  <li data-id="element-277">▸ Sacar energías negativas</li>
                  <li data-id="element-278">▸ Limpiar ambientes tensos</li>
                  <li data-id="element-279">▸ Eliminar pensamientos tóxicos</li>
                </ul>
                <div className="bg-[#F5F0E8] p-3 rounded-xl text-xs font-medium text-[#2F4538]" data-id="element-280">
                  Ej: Ritual de Limpieza Profunda con Ruda y Romero (15 min)
                </div>
              </div>

              {/* A */}
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-[#D4AF37]/10" data-id="element-281">
                <div className="text-4xl font-bold text-[#D4AF37] mb-4 notranslate" translate="no" lang="es" data-id="element-282">
                  A
                </div>
                <h5 className="font-bold text-[#2F4538] text-lg mb-2" data-id="element-283">
                  ACTIVAR{' '}
                  <span className="text-sm font-normal text-[#1a1a1a]/50" data-id="element-284">
                    (35+ rituales)
                  </span>
                </h5>
                <p className="text-sm text-[#1a1a1a]/70 mb-4" data-id="element-285">
                  Para cuando querés manifestar prosperidad, amor, protección o
                  elevar tu vibración.
                </p>
                <ul className="text-sm text-[#1a1a1a]/80 space-y-2 mb-4" data-id="element-286">
                  <li data-id="element-287">▸ Atraer abundancia y dinero</li>
                  <li data-id="element-288">▸ Aumentar magnetismo</li>
                  <li data-id="element-289">▸ Abrir caminos bloqueados</li>
                </ul>
                <div className="bg-[#F5F0E8] p-3 rounded-xl text-xs font-medium text-[#2F4538]" data-id="element-290">
                  Ej: Ritual de Prosperidad con Canela bajo Luna Llena (20 min)
                </div>
              </div>
            </div>

            <div className="bg-[#2F4538] text-[#F5F0E8] p-8 rounded-2xl relative z-10" data-id="element-291">
              <h5 className="font-bold text-[#D4AF37] mb-6 flex items-center gap-2" data-id="element-292">
                <span className="text-xl" data-id="element-293">✨</span> Cada ritual incluye:
              </h5>
              <div className="grid sm:grid-cols-2 gap-4" data-id="element-294">
                <div className="space-y-3" data-id="element-295">
                  <p className="font-medium text-[#F5F0E8]/90 flex items-start gap-2" data-id="element-296">
                    <CheckCircle2 className="w-5 h-5 text-[#D4AF37] shrink-0" data-id="element-297" />
                    3 niveles de intensidad:
                  </p>
                  <ul className="text-sm text-[#F5F0E8]/70 pl-7 space-y-1" data-id="element-298">
                    <li data-id="element-299">• Express (5 min)</li>
                    <li data-id="element-300">• Completo (15 min)</li>
                    <li data-id="element-301">• Ceremonial (30 min)</li>
                  </ul>
                </div>
                <div className="space-y-3" data-id="element-302">
                  {['Lista exacta de ingredientes (barrio)', 'Paso a paso detallado', 'Mejor momento para hacerlo', 'Qué esperar (resultados)'].map((item, i) => <div key={i} className="flex items-start gap-2 text-sm text-[#F5F0E8]/90" data-id="element-303">
                      <CheckCircle2 className="w-5 h-5 text-[#D4AF37] shrink-0" data-id="element-304" />
                      <span data-id="element-305">{item}</span>
                    </div>)}
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}